import { userConstants } from './../constants/user.constants';

const initialState = {};

export function Insubmission(state = initialState, action) {
  switch (action.type) {
    case userConstants.INSUBMISSION_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.INSUBMISSION_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.INSUBMISSION_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}